/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod";
import { safeParse } from "../../lib/schemas.js";
import { ClosedEnum } from "../../types/enums.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";

export const GetApiV3MetricsGovernanceNeuronsTotalFormat = {
  Json: "json",
  Csv: "csv",
} as const;
export type GetApiV3MetricsGovernanceNeuronsTotalFormat = ClosedEnum<
  typeof GetApiV3MetricsGovernanceNeuronsTotalFormat
>;

export type GetApiV3MetricsGovernanceNeuronsTotalRequest = {
  /**
   * End Timestamp
   */
  end?: number | null | undefined;
  format?: GetApiV3MetricsGovernanceNeuronsTotalFormat | undefined;
  /**
   * Start Timestamp
   */
  start?: number | null | undefined;
  /**
   * Float Step value
   */
  step?: number | undefined;
};

/** @internal */
export const GetApiV3MetricsGovernanceNeuronsTotalFormat$inboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsGovernanceNeuronsTotalFormat> = z
    .nativeEnum(GetApiV3MetricsGovernanceNeuronsTotalFormat);

/** @internal */
export const GetApiV3MetricsGovernanceNeuronsTotalFormat$outboundSchema:
  z.ZodNativeEnum<typeof GetApiV3MetricsGovernanceNeuronsTotalFormat> =
    GetApiV3MetricsGovernanceNeuronsTotalFormat$inboundSchema;

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsGovernanceNeuronsTotalFormat$ {
  /** @deprecated use `GetApiV3MetricsGovernanceNeuronsTotalFormat$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsGovernanceNeuronsTotalFormat$inboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceNeuronsTotalFormat$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsGovernanceNeuronsTotalFormat$outboundSchema;
}

/** @internal */
export const GetApiV3MetricsGovernanceNeuronsTotalRequest$inboundSchema:
  z.ZodType<
    GetApiV3MetricsGovernanceNeuronsTotalRequest,
    z.ZodTypeDef,
    unknown
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsGovernanceNeuronsTotalFormat$inboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/** @internal */
export type GetApiV3MetricsGovernanceNeuronsTotalRequest$Outbound = {
  end: number | null;
  format: string;
  start: number | null;
  step: number;
};

/** @internal */
export const GetApiV3MetricsGovernanceNeuronsTotalRequest$outboundSchema:
  z.ZodType<
    GetApiV3MetricsGovernanceNeuronsTotalRequest$Outbound,
    z.ZodTypeDef,
    GetApiV3MetricsGovernanceNeuronsTotalRequest
  > = z.object({
    end: z.nullable(z.number()).default(null),
    format: GetApiV3MetricsGovernanceNeuronsTotalFormat$outboundSchema.default(
      "json",
    ),
    start: z.nullable(z.number()).default(null),
    step: z.number().default(7200),
  });

/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
export namespace GetApiV3MetricsGovernanceNeuronsTotalRequest$ {
  /** @deprecated use `GetApiV3MetricsGovernanceNeuronsTotalRequest$inboundSchema` instead. */
  export const inboundSchema =
    GetApiV3MetricsGovernanceNeuronsTotalRequest$inboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceNeuronsTotalRequest$outboundSchema` instead. */
  export const outboundSchema =
    GetApiV3MetricsGovernanceNeuronsTotalRequest$outboundSchema;
  /** @deprecated use `GetApiV3MetricsGovernanceNeuronsTotalRequest$Outbound` instead. */
  export type Outbound = GetApiV3MetricsGovernanceNeuronsTotalRequest$Outbound;
}

export function getApiV3MetricsGovernanceNeuronsTotalRequestToJSON(
  getApiV3MetricsGovernanceNeuronsTotalRequest:
    GetApiV3MetricsGovernanceNeuronsTotalRequest,
): string {
  return JSON.stringify(
    GetApiV3MetricsGovernanceNeuronsTotalRequest$outboundSchema.parse(
      getApiV3MetricsGovernanceNeuronsTotalRequest,
    ),
  );
}

export function getApiV3MetricsGovernanceNeuronsTotalRequestFromJSON(
  jsonString: string,
): SafeParseResult<
  GetApiV3MetricsGovernanceNeuronsTotalRequest,
  SDKValidationError
> {
  return safeParse(
    jsonString,
    (x) =>
      GetApiV3MetricsGovernanceNeuronsTotalRequest$inboundSchema.parse(
        JSON.parse(x),
      ),
    `Failed to parse 'GetApiV3MetricsGovernanceNeuronsTotalRequest' from JSON`,
  );
}
